import { lsManager } from './local-storage';

export const cdnOnboardingTemplatePath = `${import.meta.env.VITE_CDN_BASE_URL}/skycash_import_template.csv`;
export const cdnVehiclesTemplatePath = `${import.meta.env.VITE_CDN_BASE_URL}/skycash_import_template_vehicles.csv`;
export const cdnEmployeesTemplatePath = `${import.meta.env.VITE_CDN_BASE_URL}/skycash_import_template_employees.csv`;

export const getCdnGuidelinesPath = () => {
  const lang = lsManager.get('LANGUAGE');
  return `${import.meta.env.VITE_CDN_BASE_URL}/${lang}_import_guidelines.pdf`;
};
